<template>
  <component :is="icon" />
</template>

<script lang='ts'>
import { computed } from "vue";
import { IconMapper, iconN } from "assets/icons";

export default {
  props: {
    iconName: {
      type: String as () => iconN,
      default: "box",
    },
  },
  setup(props: { iconName: iconN }) {
    const icon = computed(() => IconMapper[props.iconName]);

    return { icon };
  },
};
</script>